<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/repair/acceptance/order/joinPage" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('weixiudanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_cross_select :max="1" :component="'web_base_equipment_list'" :ids.sync="yt.conditions.equipmentId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('weixiuzhuangtai')">
            <yi_dictionary_select :type="'EQUIPMENT_REPAIR_STATUS'" :ids.sync="yt.conditions.status"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jinjichengdu')">
            <yi_dictionary_select :type="'EQUIPMENT_REPAIR_LEVEL'" :ids.sync="yt.conditions.level"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('yanshouzhuangtai')">
            <yi_dictionary_select :type="'EQUIPMENT_ACCEPTANCE_STATUS'" :ids.sync="yt.conditions.acceptanceStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('baoxiushijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createStartTime" :end.sync="yt.conditions.createEndTime"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL> </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #tupian="scope">
        <yi_upload :readOnly="true" :ids.sync="scope.row.imageIds" :limit="5"> </yi_upload>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="utils.checkPower('web_equipment_repair_acceptance_order_accept') && scope.row.status == 3 && scope.row.acceptanceStatus == 0">
            <el-button
              type="text"
              @click="
                yt.showEditDialog('jianyan', scope.row, 'w1');
                showDeal(scope.row);
              "
            >
              {{ $t('jianyan') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
        <el-form-item :label="$t('weixiudanhao')" label-width="150px" required>
          <el-input v-model="acceptData.no" disabled> </el-input>
        </el-form-item>

        <el-form-item :label="$t('weixiujishi')" label-width="150px">
          <el-input v-model="acceptData.nickname" disabled> </el-input>
        </el-form-item>

        <el-form-item :label="$t('shenheshijian')" label-width="150px">
          <yi_time_input :minMaxBase="'current'" type="datetime" :time.sync="acceptData.acceptanceTime"></yi_time_input>
        </el-form-item>

        <el-form-item :label="$t('yanshoujieguo')" label-width="150px" required>
          <yi_dictionary_select :type="'ACCEPTANCE_RESULTS'" :ids.sync="acceptData.acceptanceResult"> </yi_dictionary_select>
        </el-form-item>

        <el-form-item :label="$t('shifouchaoqi')" label-width="150px">
          <el-select v-model="acceptData.overdueFlag">
            <el-option :label="$t('fou')" value="0"></el-option>
            <el-option :label="$t('shi')" value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('shimocishu')" label-width="150px">
          <el-input v-model="acceptData.trialNum"> </el-input>
        </el-form-item>

        <el-form-item :label="$t('beizhu')" label-width="150px">
          <el-input type="textarea" max="400" v-model="acceptData.remark"> </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
        <el-button :loading="store.state.global_loading" size="mini" @click="accept()" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '设备维修-新增' } }">
          {{ $t('baocun') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx';
const date = new Date();
export default {
  name: 'web_equipment_repair_acceptance_order',
  data() {
    return {
      acceptData: {},
      columns: [
        {
          label: 'weixiudanhao',
          prop: 'no',
          fixed: 'left'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name'
        },
        {
          label: 'baoxiushijian',
          prop: 'createTime',
          type: 'time',
          width: 230
        },
        {
          label: 'baoxiuren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'guzhangmiaoshu',
          prop: 'description'
        },
        {
          label: 'weixiuzhuangtai',
          type: 'tag',
          prop: 'status',
          tags: {
            1: {
              color: '#F56C6C',
              text: this.$t('daichuli')
            },
            2: {
              color: '#E6A23C',
              text: this.$t('weixiuzhong')
            },
            3: {
              color: '#67C23A',
              text: this.$t('yiwancheng')
            },
            4: {
              color: '#969696',
              text: this.$t('shibai')
            }
          }
        },
        {
          label: 'jinjichengdu',
          prop: 'level',
          type: 'dictionary',
          key: 'EQUIPMENT_REPAIR_LEVEL',
          width: 150
        },
        {
          label: 'kaishiweixiuren',
          prop: 'repairByObject.nickname'
        },
        {
          label: 'weixiukaishishijian',
          prop: 'startTime',
          type: 'time'
        },
        {
          label: 'wanchengweixiuren',
          prop: 'endRepairerObject.nickname'
        },
        {
          label: 'weixiujieshushijian',
          prop: 'endTime',
          type: 'time'
        },
        {
          label: 'yujiwanchengshijian',
          prop: 'requiredTime',
          type: 'time'
        },
        {
          label: 'tupian',
          type: 'slot'
        },
        {
          label: 'yanshouzhuangtai',
          prop: 'acceptanceStatus',
          type: 'tag',
          tags: {
            '0': {
              color: '#E6A23C',
              text: this.$t('daiyanshou')
            },
            '1': {
              color: '#67C23A',
              text: this.$t('yiyanshou')
            },
            '2': {
              color: '#F56C6C',
              text: this.$t('yanshouweitongguo')
            }
          }
        },
        {
          label: 'jianyanshijian',
          prop: 'acceptanceTime',
          type: 'time'
        },
        {
          label: 'yanshoujieguo',
          prop: 'acceptanceResult'
        },
        {
          label: 'shifouchaoqi',
          prop: 'overdueFlag',
          type: 'tag',
          tags: {
            1: {
              color: '#F56C6C',
              text: this.$t('shi')
            },
            0: {
              color: '#67C23A',
              text: this.$t('fou')
            }
          }
        },
        {
          label: 'shimocishu',
          prop: 'trialNum'
        },
        {
          label: 'jianyanbumen',
          prop: 'acceptanceOrgObject.name'
        },
        {
          label: 'yanshouren',
          prop: 'acceptanceByObject.nickname'
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 160,
          fixed: 'right'
        }
      ]
    };
  },
  methods: {
    showDeal(row) {
      this.acceptData.repairId = row.id;
      this.acceptData.acceptanceTime = date.getTime();
      this.acceptData.no = row.no;
      this.acceptData.nickname = row.repairByObject ? row.repairByObject.nickname : '';
    },
    accept() {
      this.http
        .post('/web/repair/acceptance/order/accept', this.acceptData)
        .then(res => {
          this.acceptData = {};
          this.yt.isShowEditDialog = false;
          this.$message.success(this.$t('success'));
          this.yt.get(1);
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    exportExcel() {
      this.http.get('/web/repair/acceptance/order/joinPage?page=1&pageSize=10000', { params: { ...this.yt.conditions } }).then(res => {
        let tableFirst = this.columns.map(i => {
          if (i.label != 'caozuo' && i.label != 'tupian') {
            return this.$t(i.label);
          }
        });
        let filterFirst = tableFirst.filter(item => {
          if (item) {
            return item;
          }
        });
        console.log('tableFirst', filterFirst);
        let tableData = [];
        tableData.push(filterFirst);
        let listData = res.data.rows;
        for (let i = 0; i < listData.length; i++) {
          let dataArr = this.getTableDataArr(listData[i]);
          tableData.push(dataArr);
        }
        console.log('tableArr', tableData);
        const worksheet = XLSX.utils.aoa_to_sheet(tableData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, `设备维修验收单-${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
      });
    },
    getTableDataArr(row) {
      console.log(row);
      let dataArr = [];
      dataArr[0] = row.no;
      dataArr[1] = row.equipment.name;
      dataArr[2] = row.createTime && this.dayjs(row.createTime).format('YYYY-MM-DD HH:mm:ss');
      dataArr[3] = row.createByObject.nickname;
      dataArr[4] = row.description;
      if (row.status) {
        row.status == 1 ? (dataArr[5] = this.$t('daichuli')) : row.status == 2 ? (dataArr[5] = this.$t('weixiuzhong')) : row.status == 3 ? (dataArr[5] = this.$t('yiwancheng')) : row.status == 4 ? (dataArr[5] = this.$t('shibai')) : (dataArr[5] = '');
      } else {
        dataArr[5] = '';
      }
      if (row.level) {
        row.level == '1' ? (dataArr[6] = this.$t('yiban')) : row.level == 2 ? (dataArr[6] = this.$t('jinji')) : row.level == 3 ? (dataArr[6] = this.$t('teji')) : (dataArr[6] = '');
      } else {
        dataArr[6] = '';
      }
      dataArr[7] = row.repairByObject && row.repairByObject.nickname;
      dataArr[8] = row.startTime && this.dayjs(row.startTime).format('YYYY-MM-DD HH:mm:ss');
      dataArr[9] = row.endRepairerObject && row.endRepairerObject.nickname;
      dataArr[10] = row.endTime && this.dayjs(row.endTime).format('YYYY-MM-DD HH:mm:ss');
      if (row.acceptanceStatus) {
        row.acceptanceStatus == '0' ? (dataArr[11] = this.$t('daiyanshou')) : row.acceptanceStatus == '1' ? (dataArr[11] = this.$t('yiyanshou')) : row.acceptanceStatus == '2' ? (dataArr[11] = this.$t('yanshouweitongguo')) : (dataArr[11] = '');
      } else {
        dataArr[11] = '';
      }
      dataArr[12] = row.acceptanceTime && this.dayjs(row.acceptanceTime).format('YYYY-MM-DD HH:mm:ss');
      dataArr[13] = row.acceptanceResult;
      if (row.overdueFlag) {
        row.overdueFlag == 0 ? (dataArr[14] = this.$t('shi')) : row.overdueFlag == 1 ? (dataArr[14] = this.$t('fou')) : (dataArr[14] = '');
      } else {
        dataArr[14] = '';
      }
      dataArr[15] = row.trialNum;
      dataArr[16] = row.acceptanceOrgObject && row.acceptanceOrgObject.name;
      dataArr[17] = row.acceptanceByObject && row.acceptanceByObject.nickname;
      return dataArr;
    }
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  }
};
</script>

<style lang="scss" scoped></style>
